import { createParserSettings } from './create-parser-settings';
import { TRANSFORMATIONS } from './transformations';
import { PREFIX } from './constants';
export var parseQuery = function (input, visualization, dateModifier) {
    var query = input.query, steps = input.steps;
    var parserSettings = createParserSettings({ query: query, steps: steps, dateModifier: dateModifier });
    var transformation = parserSettings.transformation;
    var transformationHandler = TRANSFORMATIONS[transformation];
    if (transformationHandler) {
        try {
            return transformationHandler(input, parserSettings, visualization);
        }
        catch (err) {
            console.error(PREFIX + " - analysis results cannot be transformed");
        }
    }
    else {
        console.error(PREFIX + " - the provided data cannot be classified");
    }
    return {
        keys: [],
        data: [],
    };
};
